import { render, staticRenderFns } from "./PensionSleep.vue?vue&type=template&id=9fca377e&"
import script from "./PensionSleep.vue?vue&type=script&lang=js&"
export * from "./PensionSleep.vue?vue&type=script&lang=js&"
import style0 from "./PensionSleep.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports